import { Redirect, Session } from 'smg/customer-api/session';
import * as taxexemptions from 'smg/customer-api/usertaxexemptions';
import * as models from 'smg/customer-api/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { Draw, PromptNew } from '../usertaxexemptions';

void main();

async function main() {
    if (await Redirect()) {
        return;
    }
    const user = await Session().then(s => s.user);
    const cardContainer = document.querySelector<HTMLElement>('#tax-exemptions-container');

    const newAddressBtn = document.querySelector('#new-tax-exemption');
    newAddressBtn?.addEventListener('click', async () => {
        await PromptNew(user).then(drawTaxExemptions);
    });

    const taxExemptions = (await taxexemptions.UserTaxExemptions({
        'sort': 'created asc',
    })).userTaxExemptions;

    const drawTaxExemptions = async (option: models.UserTaxExemption) => {
        const taxEl = (await Draw(option)).querySelector<HTMLElement>('div');
        const cardEl = template.Clone('#card-template').firstElementChild as HTMLElement;
        const exemptionsContainer = cardEl.querySelector('.exemptions-container');
        const deleteBtn = cardEl.querySelector('.delete-btn');

        exemptionsContainer?.append(taxEl as HTMLElement);

        deleteBtn?.addEventListener('click', async () => {
            await taxexemptions.DeleteUserTaxExemption(option.id || '').
                then(() => {
                    cardEl.parentElement?.removeChild(cardEl);
                    toast.Undo('Removed tax exemption.', async () => {
                        await taxexemptions.RestoreUserTaxExemption(option.id || '');
                        void drawTaxExemptions(option);
                    });
                });
        });
        cardContainer?.insertBefore(cardEl, cardContainer.firstChild);
    };
    for (const taxExemption of taxExemptions) {
        await drawTaxExemptions(taxExemption);
    }
}